import { render } from "./NewInvoice.vue?vue&type=template&id=4f8874a6"
import script from "./NewInvoice.vue?vue&type=script&lang=js"
export * from "./NewInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__